import type { FiltersDraftOptions, FiltersDraftReturn } from '@shared/lib/filters'

import { useFiltersDraft } from '@shared/lib/filters'

import { useDisciplineContext } from './discipline-context.hook'

/**
 * The filter bars of the discipline tabs: Search-only filters, locked under the page loader — the discipline read as
 * well as the list's own read (`loading`).
 */
export const useDisciplineFiltersDraft = <TFilters extends object>(
  options: FiltersDraftOptions<TFilters>,
): FiltersDraftReturn<TFilters> => {
  const { refIsLoading: refIsContextLoading } = useDisciplineContext()

  return useFiltersDraft({
    ...options,
    loading: () => refIsContextLoading.value || options.loading(),
  })
}
